export const STORAGE_KEY_PREFIX = 'veiling';

export const COLUMN_PREFERENCES_NAMESPACE = 'column-prefs';

export const ANONYMOUS_USER_STORAGE_ID = 'anonymous';

export const ColumnPreferenceScopes = {
  SalesStatementIntermediation: 'sales-statement-intermediation',
  SalesStatementKlok: 'sales-statement-klok',
} as const;

export type IColumnPreferenceScope =
  typeof ColumnPreferenceScopes[keyof typeof ColumnPreferenceScopes];
